<template>
	<div role="dialog" aria-label="modal" aria-describedby="content-modal_aria" v-resize.initial="handleResize">
		<content-modal-header :options="headerOptions" :modalName="modalName" id="content-modal_aria" tabindex="0"/>
		<div :class="displayType()" class="modal-main-content">	
			<component v-if="contentComponent" :is="contentComponent" 
						v-bind="contentProperties" 
						@changeTitle="changeTitle"></component>
			<div v-else class="has-text-centered template-section">
				<h3 class="is-size-3">{{contentTemplate}}</h3>
			</div>
		</div>
		<content-modal-footer :options="footerOptions"/>
	</div>
</template>

<script>
	import ContentModalHeader from './ContentModalHeader.vue';
	import ContentModalFooter from './ContentModalFooter.vue';
	import resize from 'vue-resize-directive';

	export default {
		directives: {
			resize,
		},
		props: {
			header: {
				type: Object,
				default: null,
			},
			footer: {
				type: Object,
				default: null,
			},
			contentTemplate: {
				type: String,
				default: ""
			},
			contentComponent: {
				type: Function | Object,
				default: null,
			},
			contentProperties: {
				type: Object,
				default: null,
			},
			confirmationCallback: {
				type: Function,
				default: () => {
					console.warn('No confirmation callback set on modal.');
				},
			},
			// TODO this is not hooked up
			closeCallback: {
				type: Function,
				default: null,
			},
			mainContentUseAutoHeight: {
				type: Boolean,
				default: false,
			},
			modalName: {
				type: String,
				default: 'contentModal'
			},
			popup: {
				type: Boolean,
				default: false,
			}
		},
		components: {
			'content-modal-header': ContentModalHeader,
			'content-modal-footer': ContentModalFooter,
		},
		data() {
			return {
				showHeader: true,
				showFooter: true,
				headerOptions: {
					title: 'Content Title',
					backTitle: 'Back',
					showBackButton: true,
					showBackButtonIcon: true,
					showCloseButton: true,
					showHeader: true,
				},
				footerOptions: {
					confirmTitle: 'Confirm',
					showFooter: true,
				},
			}
		},
		methods: {
			displayType() {
				const mainContentClass = (this.footerOptions.showFooter);
				const isPopup = this.headerOptions && this.headerOptions.popup;
				return {
					'modal-main-content-spacing' : mainContentClass,
					'auto-height' : this.mainContentUseAutoHeight,
					'main-content--popup' : isPopup,
				};
			},
			changeTitle(title) {
				this.headerOptions.title = title;
			},
			handleResize() {
				this.$forceUpdate();
			}
		},
		mounted() {
			const isDesktop = (this.$mq === 'desktop');
			if (isDesktop) {
				const el = this.$el;
				el.firstElementChild.focus();
			}
		},
		created() {
			if (this.header) {
				this.headerOptions = _.assign(this.headerOptions, this.header);
			}
			if (this.footer) {
				this.footerOptions = _.assign(this.footerOptions, this.footer);
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';

	.global-modal {        
		background-color: #ffffff;
        overflow: scroll;
        position: relative;
		top: $navigationBarHeight !important;
		.modal-main-content {
			&.auto-height {
				padding: 0rem;
 				max-height: none;
				height: auto;
			}
			overflow-x: hidden;
		}
	}

	.template-section {
		margin-top: 3em;
	}


	@include desktop {
		.modal-main-content {
			max-height: 75vh;
			min-height: 35vh;
			max-width: 90vw;
			overflow: scroll;
			background-color: $checkoutBackgroundColor;

			&.auto-height {
				padding: 2rem;
				height: auto;
			}
		}
	}

	@include mobile {
		.modal-main-content {
			width: 100vw;
			min-height: 100vh;
			padding-top: $mobileNavigationHeight;
			padding-bottom: 70px;
			// TODO have a content modal background
			background-color: $checkoutBackgroundColor;
		}

		.modal-main-content {
			&.auto-height {
				padding: 0;
			}
		}

		[data-modal="loginModal"] {
			.modal-main-content {
				padding-top: $mobileNavigationHeight;
				// TODO have a login modal background
				background-color: $checkoutBackgroundColor;
			}
		}

		.global-modal {
			top: 0em !important;
			width: 100% !important;
			height: 100% !important;
			left: 0px !important;
		}

		.modal-main-content-spacing {
			margin-bottom: 30%;
		}

		.main-content--popup {
			width: 420px;
			max-width: 100%;
			min-height: auto;
			padding: 0;
		}
	}

	@include tablet {
		.modal-main-content {
			width: 100%;
		}
	}
	
</style>


// WEBPACK FOOTER //
// src/components/global-modal/ContentModal.vue